import type { Observable } from 'rxjs'

/** A date shift saved some tasks before a later request failed. */
export class TaskDateShiftError extends Error {
  /**
   * Keeps a retry that includes only tasks that have not been saved.
   * @param {unknown} cause The failed request.
   * @param {Observable<void>} retry
   */
  constructor(
    cause: unknown,
    readonly retry: Observable<void>
  ) {
    super('Some task dates could not be moved.', { cause })
  }
}
